import { useTranslate } from "ra-core";
import { Link } from "react-router";

import { useCurrentProject } from "./useCurrentProject";

/**
 * No project to show: an employee nobody has added to a project yet, or the
 * owner when every project is archived.
 */
export const NoProjects = () => {
  const translate = useTranslate();
  const { isOwner } = useCurrentProject();
  return (
    <div className="flex flex-col items-center gap-2 py-24 text-center">
      <h3 className="text-lg font-semibold">
        {translate(
          isOwner ? "crm.projects.no_active_title" : "crm.projects.none_title",
        )}
      </h3>
      <p className="text-sm text-muted-foreground max-w-sm">
        {translate(
          isOwner
            ? "crm.projects.no_active_description"
            : "crm.projects.none_description",
        )}
      </p>
      {isOwner ? (
        <Link
          to="/settings/projects"
          className="text-sm font-medium text-primary-ink underline"
        >
          {translate("crm.projects.open_settings")}
        </Link>
      ) : null}
    </div>
  );
};
